import { RiCalendarEventLine } from "@itandi/itandi-bb-ui";
import type React from "react";
import type { Deal } from "~/models/Deal";
import type { InspectionCandidateDate } from "~/models/InspectionCandidateDate";
import { formatDate } from "~/utils/DateUtil";
import Styles from "./InspectionCandidateDatesList.module.scss";

type Props = {
	deal: Deal;
};

/**
 * 訪問希望日程一覧
 *
 * @for client, vendor
 */

export function InspectionCandidateDatesList({ deal }: Props) {
	const { dealInspectionCandidateDates: candidateDates } = deal;
	if (candidateDates.length === 0) return null;
	return (
		<div className={Styles.InspectionCandidateDates}>
			<h3 className={Styles.CandidateTitle}>
				<RiCalendarEventLine className={Styles.Icon} />
				訪問希望日程
			</h3>
			{candidateDates.map(
				(candidateDate: InspectionCandidateDate): React.ReactNode => (
					<div className={Styles.CandidateDateRow} key={candidateDate.id}>
						<span className={Styles.Title}>第{candidateDate.sort}希望</span>
						<span className={Styles.Date}>
							{formatDate(candidateDate.date)}
						</span>
						{candidateDate.time}
					</div>
				)
			)}
		</div>
	);
}
